module.exports = __webpack_public_path__ + "assets/img/left-title-open-cc9200c7.png";